import Images from "@/assets/images";
import Icons from "@/assets/icons";
import FBTrackingService from "@/services/fbTrackingService";
import SubscriptionServices from "@/services/subscriptionServices";
import { Image } from "expo-image";
import { router } from "expo-router";
import React, { useEffect, useRef } from "react";
import { Animated, Easing, Text, View, ActivityIndicator } from "react-native";
import { StyleSheet } from "@/utils/appStyleSheet";
import { SafeAreaView } from "react-native-safe-area-context";
import { FontFamilies } from "@/constants/Typography";
import { Colors } from "@/constants/Colors";

const AnalyzingScreen = () => {
  const spinValue = useRef(new Animated.Value(0)).current;
  const coinRotation = useRef(new Animated.Value(0)).current;

  useEffect(() => {
    FBTrackingService.trackViewContent("my-money-analyzing");
    SubscriptionServices.createSubscription().then(() => {
      setTimeout(() => {
        router.replace("/my-money/setup-income");
      }, 2000);
    });

    // Loading spinner animation
    const spinAnimation = Animated.loop(
      Animated.timing(spinValue, {
        toValue: 1,
        duration: 1500,
        easing: Easing.linear,
        useNativeDriver: true,
      })
    );
    spinAnimation.start();

    // Coin floating/rotation animation
    const coinAnimation = Animated.loop(
      Animated.sequence([
        Animated.timing(coinRotation, {
          toValue: 1,
          duration: 2000,
          easing: Easing.inOut(Easing.ease),
          useNativeDriver: true,
        }),
        Animated.timing(coinRotation, {
          toValue: 0,
          duration: 2000,
          easing: Easing.inOut(Easing.ease),
          useNativeDriver: true,
        }),
      ])
    );
    coinAnimation.start();

    return () => {
      spinAnimation.stop();
      coinAnimation.stop();
    };
  }, []);

  const coinScale = coinRotation.interpolate({
    inputRange: [0, 0.5, 1],
    outputRange: [1, 1.05, 1],
  });

  const coinTranslateY = coinRotation.interpolate({
    inputRange: [0, 0.5, 1],
    outputRange: [0, -10, 0],
  });

  return (
    <SafeAreaView style={styles.container}>
      {/* Header with Logo */}
      <View style={styles.header}>
        <Icons.LogoWithTextBlack width={142} height={34} />
      </View>

      {/* Content */}
      <View style={styles.content}>
        {/* Coin Image */}
        <Animated.View
          style={[
            styles.coinContainer,
            {
              transform: [
                { scale: coinScale },
                { translateY: coinTranslateY },
                { rotate: "-25deg" },
                { scaleX: -1 },
              ],
            },
          ]}
        >
          <Image source={Images.coin3d} style={styles.coinImage} />
        </Animated.View>

        {/* Text */}
        <View style={styles.textContainer}>
          <Text style={styles.title}>Calculating</Text>
          <Text style={styles.title}>your income...</Text>
        </View>
      </View>

      {/* Loading Spinner at Bottom */}
      <View style={styles.loadingContainer}>
        <ActivityIndicator size="large" color={Colors.primary} />
      </View>
    </SafeAreaView>
  );
};

export default AnalyzingScreen;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#FFFFFF",
  },
  header: {
    alignItems: "center",
    paddingTop: 16,
    paddingBottom: 24,
  },
  content: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    paddingHorizontal: 32,
    gap: 16,
  },
  coinContainer: {
    width: 140,
    height: 140,
    justifyContent: "center",
    alignItems: "center",
  },
  coinImage: {
    width: 120,
    height: 120,
  },
  textContainer: {
    alignItems: "center",
  },
  title: {
    fontSize: 24,
    fontFamily: FontFamilies.InterTight.Bold,
    color: "#161D14",
    textAlign: "center",
    lineHeight: 32,
  },
  loadingContainer: {
    paddingBottom: 40,
    alignItems: "center",
  },
});
